import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 40px 0;
`;

const Container = styled.div.attrs({ className: 'app-container' })`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 48px;
`;

const SectionTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 30px;
  margin-top: 20px;
  color: var(--text-color);
`;

const PolicyContent = styled.div`
  line-height: 1.6;
  color: var(--text-color);
  margin-bottom: 120px;
  
  h2 {
    font-size: 1.8rem;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 1.4rem;
    margin-top: 30px;
    margin-bottom: 15px;
  }
  
  p {
    margin-bottom: 20px;
  }
  
  ul {
    margin-bottom: 20px;
    padding-left: 20px;
    list-style-type: disc;
  }
  
  li {
    margin-bottom: 10px;
  }
`;

const PrivacyPage = () => {
    return (
        <PageContainer>
            <Container>
                <SectionTitle>Privacy Policy</SectionTitle>

                <PolicyContent>
                    <p>Effective Date: [Insert Date]</p>

                    <p>Interstellar Map ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website [https://interstellarmap.com](https://interstellarmap.com), make a purchase, or contact us.
                    </p>

                    <h2>1. Who We Are</h2>
                    <p>
                    We create personalized star maps that depict the exact alignment of stars, planets, and constellations as seen from a specific location on a chosen date. Our maps are based on scientifically accurate data from sources such as the Hipparcos Catalog and IAU guidelines. We offer full customization and provide both digital and physical products, shipped globally.
                    </p>

                    <h3>Legal Information</h3>

                    <ul>
                      <li>Company Legal Name: [To be updated - TBD]</li>
                      <li>Company Registration Number: [TBD]</li>
                      <li>Registered Address: [TBD]</li>
                      <li>Jurisdiction: United Kingdom</li>
                    </ul>

                    <p>We are committed to compliance with applicable privacy laws including the General Data Protection Regulation (GDPR), Payment Services Directive 2 (PSD2), and Strong Customer Authentication (SCA).
                    </p>

                    <h2>2. Information We Collect</h2>
                    <p>We collect the following types of information:
                    </p>
                    <ul>
                      <li>Personal Information: Name, email address, shipping address, billing details, and other information you provide when placing an order or contacting us.
                      </li>
                      <li>Order Details: Selected star map features, location, date/time specifications.
                      </li>
                      <li>Payment Information Processed through secure third-party payment providers in compliance with PSD2 and SCA regulations.                      </li>
                    </ul>

                    <p>We do not use external tracking systems or analytics tools.</p>

                    <h2>3. How We Use Your Information</h2>
                    <p>We use the information we collect for various purposes, including:</p>
                    <ul>
                        <li>To process and fulfill your orders</li>
                        <li>To improve our website and services</li>
                        <li>To communicate with you about your orders and our services</li>
                        <li>To provide customer support</li>
                        <li>To comply with legal obligations</li>
                    </ul>

                    <h2>4. Sharing Your Information</h2>
                    <p>We do not sell or share your personal information with third parties for marketing purposes.
                    </p>
                    <p>We may disclose your information to:
                    </p>
                    <ul>
                      <li>Shipping and logistics providers (information disclosed at checkout)</li>
                      <li>Payment service providers to process transactions securely</li>
                      <li>Legal authorities when required by law</li>
                    </ul>

                    <h2>5. International Shipping and Delivery</h2>
                    <p>We ship worldwide. Delivery services vary by destination and will be listed at checkout. Since we work with multiple providers, specific courier details will be shared during the ordering process.
                    </p>

                    <h2>6. Your Rights</h2>
                    <p>
                    Under GDPR, you have the right to:
                    </p>

                    <ul>
                      <li>Access the personal data we hold about you</li>
                      <li>Correct inaccuracies in your data</li>
                      <li>Request deletion of your personal data</li>
                      <li>Restrict or object to processing in certain cases</li>
                      <li>Lodge a complaint with a data protection authority in the UK or your local EU member state</li>
                    </ul>

                    <h2>7. Data Retention</h2>
                    <p>
                    We retain your personal data only as long as necessary to fulfill the purposes for which it was collected, including legal and accounting requirements.
                    </p>

                    <h2>8. Refund and Return Policy</h2>
                    <p>We offer a 14-day refund period from the date of delivery. For more information, contact us at info@interstellarmap.com.</p>

                    <h2>9. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy or how your data is handled, please contact us:
                    </p>
                    <ul>
                      <li>Email: info@interstellarmap.com</li>
                      <li>Website: https://interstellarmap.com</li>
                    </ul>

                    <h2>10. Updates to This Policy</h2>
                    <p>We may update this Privacy Policy periodically. Any changes will be posted on this page with an updated effective date.
                    </p>
                </PolicyContent>
            </Container>
        </PageContainer>
    );
};

export default PrivacyPage; 